import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import '../styles/discrete-booking.css';


console.log('BookingForm styles loaded:', {
    cssFile: document.querySelector('link[href*="discrete-booking.css"]'),
    appliedStyles: window.getComputedStyle(document.documentElement)
});

console.log('BookingForm styles loaded:', {
    cssFile: document.querySelector('link[href*="BookingForm.css"]'),
    appliedStyles: window.getComputedStyle(document.documentElement)
});

const billingTypes = [
    {
        id: 'regular',
        label: 'Standardní fakturace',
        description: 'Běžná fakturace úklidových služeb',
        icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
        )
    },
    {
        id: 'pc_service',
        label: 'Servis počítačů',
        description: 'Fakturace vedená jako IT služby a diagnostika',
        icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
        )
    },
    {
        id: 'windows',
        label: 'Mytí oken',
        description: 'Fakturace vedená jako úklid oken a výloh',
        icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
        )
    },
    {
        id: 'garden',
        label: 'Zahradnické práce',
        description: 'Fakturace vedená jako údržba zeleně',
        icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        )
    },
    {
        id: 'consulting',
        label: 'Poradenství',
        description: 'Fakturace vedená jako konzultační služby',
        icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        )
    }
];

const PriceCalculator = ({ onComplete = () => {} }) => {
    const [area, setArea] = useState('');
    const [price, setPrice] = useState(0);
    const [selectedBilling, setSelectedBilling] = useState(null);
    const [selectedType, setSelectedType] = useState(null);
    const [selectedIntent, setSelectedIntent] = useState(null);
    const [generatingActivities, setGeneratingActivities] = useState(false);
    const [currentActivity, setCurrentActivity] = useState('');
    const [showBillingQuestion, setShowBillingQuestion] = useState(false);
    const [needsAlternativeBilling, setNeedsAlternativeBilling] = useState(null);
    const [debug, setDebug] = useState({});
    const baseRate = 800;
    const [step, setStep] = useState('initial');
    const [contactDetails, setContactDetails] = useState({
        name: '',
        email: '',
        phone: '',
        preferredContact: null
    });
    const [generatingCode, setGeneratingCode] = useState(false);
    const [securityCode, setSecurityCode] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [preferredMethod, setPreferredMethod] = useState(null);
    const [isGenerating, setIsGenerating] = useState(false);
    const [generatedCode, setGeneratedCode] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [inputError, setInputError] = useState('');
    const [showSuccess, setShowSuccess] = useState(true);
    const [countdown, setCountdown] = useState(15);
    const [isClosing, setIsClosing] = useState(false);
    const [showCloseButton, setShowCloseButton] = useState(false);
    const [shouldClose, setShouldClose] = useState(false);

    // Upravený useEffect pro odpočet
    useEffect(() => {
        let timer;
        if (isSuccess && countdown > 0) {
            console.log('Starting countdown:', countdown);
            timer = setInterval(() => {
                setCountdown(prev => {
                    console.log('Updating countdown:', prev - 1);
                    return prev - 1;
                });
            }, 1000);
        } else if (countdown === 0) {
            console.log('Countdown reached zero');
            setShowCloseButton(true);
        }

        return () => {
            if (timer) {
                console.log('Clearing timer');
                clearInterval(timer);
            }
        };
    }, [isSuccess, countdown]);

    const handleClose = () => {
        console.log('Manual close clicked');
        setIsClosing(true);
        setTimeout(() => {
            setShouldClose(true);
        }, 1000);
    };

    const intents = [
        {
            id: 'clean',
            label: 'Chci vyčistit prostor',
            description: 'Diskrétní a profesionální řešení pro váš klid',
            detail: 'Kompletní vyčištění prostoru od nežádoucích zařízení',
            icon: (
                <svg className="w-8 h-8 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            ),
            style: 'from-emerald-50 to-emerald-100'
        },
        {
            id: 'secure',
            label: 'Chci mít jistotu dvou uší',
            description: 'Pro ty, kdo chtějí mluvit opravdu v soukromí',
            detail: 'Preventivní ochrana proti odposlechům a sledování',
            icon: (
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
            ),
            style: 'from-blue-50 to-blue-100'
        }
    ];

    const objectTypes = [
        { 
            id: 'apartment', 
            label: 'Bytová jednotka', 
            description: 'Byty a bytové prostory',
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
            )
        },
        { 
            id: 'house', 
            label: 'Rodinný dům', 
            description: 'Domy a obytné budovy',
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
            )
        },
        { 
            id: 'commercial', 
            label: 'Komerční prostor', 
            description: 'Kanceláře a obchodní prostory',
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
            )
        },
        { 
            id: 'industrial', 
            label: 'Průmyslový objekt', 
            description: 'Výrobní a skladové prostory',
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5m4-6h3a1 1 0 001-1V7a1 1 0 00-1-1h-3m-6 0h3a1 1 0 011 1v7a1 1 0 01-1 1h-3m-6 0h6" />
                </svg>
            )
        },
        { 
            id: 'vehicle', 
            label: 'Vozový park', 
            description: 'Automobily a dopravní prostředky',
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
            )
        }
    ];

    const activities = [
        'Analýza firemních procesů',
        'Bezpečnostní audit IT infrastruktury',
        'Konzultace GDPR compliance',
        'Optimalizace síťové architektury',
        'Penetrační testování',
        'Revize kódové základny',
        'Školení zaměstnanců',
        'Dokumentace systémových procesů',
        'Analýza datových toků',
        'Implementace zabezpečení'
    ];

    const alternativeBillingOptions = [
        { 
            id: 'it', 
            label: 'IT Konzultace', 
            description: 'Fakturace vedená jako IT poradenství a systémová analýza' 
        },
        { 
            id: 'security', 
            label: 'Bezpečnostní audit', 
            description: 'Fakturace vedená jako komplexní bezpečnostní audit' 
        },
        { 
            id: 'gdpr', 
            label: 'GDPR Compliance', 
            description: 'Fakturace vedená jako konzultace GDPR a datové ochrany' 
        },
        { 
            id: 'custom', 
            label: 'Vlastní požadavek', 
            description: 'Specifikujte vlastní způsob fakturace dle vašich potřeb' 
        }
    ];

    const [selectedActivity, setSelectedActivity] = useState(null);

    const generateRandomActivities = async () => {
        setGeneratingActivities(true);
        for (let i = 0; i < 12; i++) {
            const randomActivity = activities[Math.floor(Math.random() * activities.length)];
            setCurrentActivity(randomActivity);
            await new Promise(r => setTimeout(r, 400));
        }
        setGeneratingActivities(false);
        setSelectedActivity(currentActivity);
    };

    const calculatePrice = (value) => {
        if (!isNaN(value) && value > 0) {
            setArea(value);
            // Animace kalkulace
            let currentPrice = 0;
            const targetPrice = value * baseRate;
            const step = targetPrice / 20; // 20 kroků animace
            
            const interval = setInterval(() => {
                if (currentPrice < targetPrice) {
                    currentPrice += step;
                    setPrice(Math.min(currentPrice, targetPrice));
                } else {
                    clearInterval(interval);
                }
            }, 50);
        } else {
            setArea('');
            setPrice(0);
        }
    };

    const handleBillingOptionSelect = (optionId) => {
        console.log('Billing option selected:', optionId);
        setSelectedBilling(optionId);
        setStep('contact');
    };

    const handleBillingQuestion = (needsAlternative) => {
        console.log('Billing question answered:', needsAlternative);
        setNeedsAlternativeBilling(needsAlternative);
        
        if (needsAlternative) {
            console.log('Starting activity generation');
            generateRandomActivities();
        } else {
            console.log('Completing without alternative billing');
            handleComplete(price);
        }
    };

    const handleComplete = (finalPrice) => {
        console.log('Handling completion with price:', finalPrice);
        if (typeof onComplete === 'function') {
            try {
                onComplete(finalPrice);
                console.log('Completion successful');
            } catch (error) {
                console.error('Error during completion:', error);
            }
        } else {
            console.warn('onComplete not available');
        }
    };

    const generateSecurityCode = async () => {
        setGeneratingCode(true);
        let code = '';
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        
        for (let i = 0; i < 16; i++) {
            const randomChar = chars[Math.floor(Math.random() * chars.length)];
            code += randomChar;
            setSecurityCode(code);
            await new Promise(r => setTimeout(r, 100));
        }
        
        setGeneratingCode(false);
        return code;
    };

    const generateBookingCode = () => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let code = '';
        for (let i = 0; i < 8; i++) {
            code += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return code;
    };

    const generateBookingCodeWithEffect = () => {
        setIsGenerating(true);
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let code = '';
        let currentIndex = 0;
        
        const generateInterval = setInterval(() => {
            if (currentIndex < 8) {
                code += chars.charAt(Math.floor(Math.random() * chars.length));
                currentIndex++;
                setGeneratedCode(code.padEnd(8, '_'));
            } else {
                clearInterval(generateInterval);
                setIsGenerating(false);
                return code;
            }
        }, 100);

        return new Promise(resolve => {
            setTimeout(() => {
                clearInterval(generateInterval);
                setIsGenerating(false);
                resolve(code || generateBookingCode());
            }, 1000);
        });
    };

    // Validační funkce
    const validatePhone = (phone) => {
        const cleanPhone = phone.replace(/\s+/g, '').replace(/[-()+]/g, '');
        return /^(\+420|420)?\d{9}$/.test(cleanPhone);
    };

    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleInputChange = (e) => {
        const { value } = e.target;
        
        if (preferredMethod === 'signal') {
            let formattedValue = value;
            if (!value.startsWith('+420')) {
                formattedValue = '+420' + value.replace(/^\+420/, '');
            }
            
            setContactDetails({
                ...contactDetails,
                phone: formattedValue
            });
        } else {
            setContactDetails({
                ...contactDetails,
                email: value
            });
        }
    };

    const handleContactSubmit = async (e) => {
        e.preventDefault();
        
        if (preferredMethod === 'signal') {
            if (!validatePhone(contactDetails.phone)) {
                setInputError('Zadejte prosím platné telefonní číslo');
                return;
            }
        } else {
            if (!validateEmail(contactDetails.email)) {
                setInputError('Zadejte prosím platný email');
                return;
            }
        }
        
        setInputError('');
        setIsSubmitting(true);
        
        try {
            const bookingCode = await generateBookingCodeWithEffect();

            const bookingData = {
                booking_code: bookingCode,
                area_size: area,
                contact_method: preferredMethod,
                contact_info: contactDetails,
                location: selectedType,
                concerns: selectedIntent,
                billing_type: selectedBilling,
                estimated_price: price
            };

            const response = await fetch('/wp-json/discrete-booking/v1/bookings', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(bookingData)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            
            // Počkáme 2 sekundy pro lepší UX
            await new Promise(resolve => setTimeout(resolve, 2000));
            
            if (result) {
                setIsSuccess(true);
                onComplete({
                    ...result,
                    booking_code: bookingCode
                });
            }
        } catch (error) {
            console.error('Chyba při odesílání:', error);
            setInputError('Došlo k chybě při odesílání. Zkuste to prosím znovu.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleIntentSelect = (intentId) => {
        setSelectedIntent(intentId);
        setStep('type');
    };

    const handleTypeSelect = (typeId) => {
        setSelectedType(typeId);
        setStep('price');
    };

    const handleAreaChange = (value) => {
        calculatePrice(value);
    };

    const handleBack = () => {
        const steps = {
            'type-select': 'initial',
            'area-input': 'type-select',
            'billing-type': 'area-input',
            'contact-method': 'billing-type',
            'contact-form': 'contact-method'
        };
        setStep(steps[step]);
    };

    const renderIntentSelection = () => (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="intent-selection"
        >
            <h3>Vyberte typ služby</h3>
            <div className="intent-options">
                {intents.map((intent) => (
                    <motion.div
                        key={intent.id}
                        whileHover={{ scale: 1.02 }}
                        className={`intent-option ${selectedIntent === intent.id ? 'selected' : ''}`}
                        onClick={() => handleIntentSelect(intent.id)}
                    >
                        <div className="intent-icon">{intent.icon}</div>
                        <div className="intent-details">
                            <h4>{intent.label}</h4>
                            <p>{intent.description}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );

    const renderObjectTypeSelect = () => (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="type-selection"
        >
            <h3>Vyberte typ objektu</h3>
            <div className="type-options">
                {objectTypes.map((type) => (
                    <button
                        key={type.id}
                        onClick={() => {
                            setSelectedType(type.id);
                            setStep('area-input');
                        }}
                        className={`type-option ${selectedType === type.id ? 'selected' : ''}`}
                    >
                        <div className="type-icon">{type.icon}</div>
                        <div className="type-details">
                            <h4>{type.label}</h4>
                            <p>{type.description}</p>
                        </div>
                    </button>
                ))}
            </div>
        </motion.div>
    );

    const renderAreaInput = () => (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="area-input"
        >
            <h3>Zadejte velikost prostoru</h3>
            <div className="input-wrapper">
                <input
                    type="number"
                    value={area}
                    onChange={(e) => handleAreaChange(e.target.value)}
                    className="area-input-field"
                    placeholder="Zadejte plochu v m²"
                />
                <span className="unit">m²</span>
            </div>
            {price > 0 && (
                <div className="price-display">
                    <p>Orientační cena: {new Intl.NumberFormat('cs-CZ').format(price)} Kč</p>
                    <button 
                        onClick={() => setStep('billing-type')} 
                        className="continue-button"
                    >
                        Pokračovat
                    </button>
                </div>
            )}
            <div className="navigation-buttons">
                <button 
                    onClick={handleBack} 
                    className="back-button"
                >
                    Zpět
                </button>
            </div>
        </motion.div>
    );

    const renderContactMethodSelect = () => (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="contact-method-select"
        >
            <h3>Zvolte způsob kontaktu</h3>
            <div className="contact-options">
                <button
                    type="button"
                    className={`contact-option ${preferredMethod === 'signal' ? 'selected' : ''}`}
                    onClick={() => {
                        setPreferredMethod('signal');
                        setStep('contact-form');
                    }}
                >
                    <svg className="w-8 h-8 text-blue-500" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
                    </svg>
                    <span>Signal</span>
                </button>
                <button
                    type="button"
                    className={`contact-option ${preferredMethod === 'form' ? 'selected' : ''}`}
                    onClick={() => {
                        setPreferredMethod('form');
                        setStep('contact-form');
                    }}
                >
                    <svg className="w-8 h-8 text-green-500" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/>
                    </svg>
                    <span>Šifrovaný formulář</span>
                </button>
            </div>
        </motion.div>
    );

    const renderContactForm = () => (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="contact-form"
        >
            <h3>Kontaktní údaje</h3>
            <form onSubmit={handleContactSubmit}>
                <div className="form-group">
                    <label className="form-label">
                        {preferredMethod === 'signal' ? 'Signal číslo' : 'E-mail'}
                    </label>
                    <input
                        type={preferredMethod === 'signal' ? 'tel' : 'email'}
                        className={`form-input ${inputError ? 'error' : ''}`}
                        value={preferredMethod === 'signal' ? 
                            (contactDetails.phone || '+420') : 
                            contactDetails.email}
                        onChange={handleInputChange}
                        placeholder={preferredMethod === 'signal' ? 
                            '+420 XXX XXX XXX' : 
                            'vas@email.cz'}
                        required
                    />
                    {inputError && (
                        <div className="error-message">
                            {inputError}
                        </div>
                    )}
                </div>
                <div className="submit-button-wrapper">
                    <button 
                        type="submit" 
                        className="submit-button"
                    >
                        Odeslat poptávku
                    </button>
                </div>
            </form>
        </motion.div>
    );

    const renderSubmissionStatus = () => (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="submission-status"
        >
            <div className="code-generation">
                <h3>Generuji bezpečný kód vaší poptávky</h3>
                <div className="code-display">
                    {generatedCode || '________'}
                </div>
                <div className="status-message">
                    {isGenerating ? (
                        <span className="generating">Generuji unikátní kód...</span>
                    ) : (
                        <span className="generated">Kód vygenerován</span>
                    )}
                </div>
            </div>
            {!isGenerating && (
                <div className="submission-progress">
                    <div className="progress-bar">
                        <div 
                            className="progress-fill"
                            style={{ width: isSubmitting ? '100%' : '0%' }}
                        ></div>
                    </div>
                    <p>Odesílám vaši poptávku...</p>
                </div>
            )}
        </motion.div>
    );

    const renderBillingTypeSelect = () => (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="billing-type-selection"
        >
            <h3>Způsob fakturace</h3>
            <div className="billing-options">
                {billingTypes.map((type) => (
                    <button
                        key={type.id}
                        onClick={() => {
                            setSelectedBilling(type.id);
                            setStep('contact-method');
                        }}
                        className={`billing-option ${selectedBilling === type.id ? 'selected' : ''}`}
                    >
                        <div className="billing-icon">{type.icon}</div>
                        <div className="billing-details">
                            <h4>{type.label}</h4>
                            <p>{type.description}</p>
                        </div>
                    </button>
                ))}
            </div>
        </motion.div>
    );

    const handleAreaSubmit = () => {
        if (price > 0) {
            setStep('billing-type');
        }
    };

    const renderInitialStep = () => (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="intent-selection"
        >
            <h3>Vyberte typ služby</h3>
            <div className="intent-options">
                {intents.map((intent) => (
                    <button
                        key={intent.id}
                        onClick={() => {
                            setSelectedIntent(intent.id);
                            setStep('type-select');
                        }}
                        className={`intent-option ${selectedIntent === intent.id ? 'selected' : ''}`}
                    >
                        {intent.icon}
                        <div className="intent-details">
                            <h4>{intent.label}</h4>
                            <p>{intent.description}</p>
                        </div>
                    </button>
                ))}
            </div>
        </motion.div>
    );

    const renderSuccessMessage = () => (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className={`success-message ${isClosing ? 'fade-out' : ''}`}
        >
            <div className="success-icon">
                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                    <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
                    <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                </svg>
            </div>
            <h3>Děkujeme za Vaši poptávku</h3>
            <div className="booking-details">
                <p className="booking-code">Váš kód: <strong>{generatedCode}</strong></p>
                <p className="contact-info">
                    {preferredMethod === 'signal' 
                        ? 'Brzy Vás budeme kontaktovat přes Signal.'
                        : 'Brzy Vás budeme kontaktovat na zadaný email.'}
                </p>
            </div>
            <div className="privacy-note">
                <p>Vaše data jsou u nás v bezpečí. Všechny informace jsou šifrovány a po vyřízení automaticky smázány.</p>
            </div>
            <div className="countdown">
                {countdown > 0 ? (
                    `Toto okno zůstane otevřené ještě ${countdown} sekund`
                ) : (
                    <button 
                        onClick={handleClose}
                        className="close-button"
                    >
                        Zavřít okno
                    </button>
                )}
            </div>
        </motion.div>
    );

    return (
        <div id="discrete-booking-app">
            <div className="discrete-booking-wrapper">
                <motion.div 
                    className="booking-form"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <div className="booking-form-container">
                        {isSuccess && !shouldClose ? (
                            renderSuccessMessage()
                        ) : isGenerating || isSubmitting ? (
                            renderSubmissionStatus()
                        ) : (
                            <>
                                {step === 'initial' && renderInitialStep()}
                                {step === 'type-select' && renderObjectTypeSelect()}
                                {step === 'area-input' && renderAreaInput()}
                                {step === 'billing-type' && renderBillingTypeSelect()}
                                {step === 'contact-method' && renderContactMethodSelect()}
                                {step === 'contact-form' && renderContactForm()}
                            </>
                        )}
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default PriceCalculator;